import { Box, Text } from '@factorialco/deprecated-design-system'
import { SecuritySettingsSamlSetupModalDomainFragment } from 'generated/resources/graphql'

import Selector from 'modules/core/components/Selector'
import i18n from 'modules/core/lib/i18n'

import { type SamlForm } from '../useSamlForm'

interface Props {
  domains: SecuritySettingsSamlSetupModalDomainFragment[]
  form: SamlForm
}

const Domains = ({ domains, form }: Props) => {
  return (
    <Box gap="s16" paddingBottom="s16">
      <Text.Normal size="300" color="grey800">
        {i18n.t('settings.edit_company.saml_sso.modal.domains.description')}
      </Text.Normal>
      <Selector.Popover
        isMultiSelect
        inputStyle="tags"
        hasSearch={false}
        placeholder={i18n.t('settings.edit_company.saml_sso.modal.domains.input_placeholder')}
        value={form.values.domainIds}
        blankLabel=""
        onChange={(value) => {
          // eslint-disable-next-line no-type-assertion/no-type-assertion
          form.setFieldValue('domainIds', value as number[])
        }}
      >
        {domains.map((d) => (
          <Selector.Option key={d.id} value={d.id} label={d.domainName} searchValue={d.domainName}>
            {d.domainName}
          </Selector.Option>
        ))}
      </Selector.Popover>
    </Box>
  )
}

export default Domains
